import { Card, CardContent } from './ui/card'

type Props = { error: unknown }

function ErrorCard({ error }: Props) {
  return (
    <div className="ion-padding mx-auto max-w-md">
      <Card>
        <CardContent>
          <p className="text-lg">
            <span className="text-ion-color-danger font-semibold">Error: </span>
            {error instanceof Error ? error.message : 'Unknown Error.'}
          </p>
        </CardContent>
      </Card>
    </div>
  )
}

export { ErrorCard }
